import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft, faArrowRight, faPen, faTrashAlt, faPlus, faMinus, faThList, faUser, faMask, faSignOutAlt, faSyncAlt, faRedo, faDownload, faHistory, faInfo, faCheck, faPlusCircle, faFileWord, faToggleOff, faToggleOn, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  load: function() {
    library.add(faUserSecret);
    library.add(faSpinner);
    library.add(faArrowLeft);
    library.add(faArrowRight);
    library.add(faPen);
    library.add(faTrashAlt);
    library.add(faPlus);
    library.add(faMinus);
    library.add(faThList);
    library.add(faUser);
    library.add(faMask);
    library.add(faSignOutAlt);
    library.add(faSyncAlt);
    library.add(faRedo);
    library.add(faDownload);
    library.add(faHistory);
    library.add(faInfo);
    library.add(faCheck);
    library.add(faPlusCircle);
    library.add(faFileWord);
    library.add(faToggleOff);
    library.add(faToggleOn);
    library.add(faTimesCircle);
  },
};
